import { Module, MutationTree, ActionTree, GetterTree } from "vuex";
type OutboundType = "quick" | "freight" | "parcel" | "mass-parcel" | "registry";

export class completeState {
  paymentMethodType: paymentMethodType = "billing";
  completeList:
    | api.outbound.parcel.responseResult[]
    | api.outbound.quick.responseResult[]
    | outbound.registry.registryComplete = [];

  outboundCompleteType: OutboundType = "quick";
}
const Mutations: MutationTree<completeState> = {
  updateCompleteList(state: completeState, payload) {
    state.completeList = payload;
  },
  updateOutboundCompleteType(state: completeState, payload) {
    state.outboundCompleteType = payload;
  },
};
const Actions: ActionTree<completeState, any> = {
  updateCompleteList({ commit }, payload) {
    commit("updateCompleteList", payload);
  },
  updateOutboundCompleteType({ commit }, payload) {
    commit("updateOutboundCompleteType", payload);
  },
};
const Getters: GetterTree<completeState, any> = {};

const module: Module<completeState, any> = {
  namespaced: true,
  state: new completeState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
